export const checkoutTypes = {
  CHECKOUT: 'checkout',
  POPUP: 'popup',
  EMBED: 'embed',
  IFRAME: 'iframe',
};
